<template>
    <span class="animated-scale-pop" :class="{ animate: shouldAnimate }">
        <slot>{{ value }}</slot>
    </span>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";

const props = defineProps({
    value: { type: [Number, String], default: "" },
    delay: { type: Number, default: 0 },
    duration: { type: Number, default: 600 },
    startOnMount: { type: Boolean, default: true },
});

const shouldAnimate = ref(false);

const animate = () => {
    shouldAnimate.value = false;
    setTimeout(() => {
        shouldAnimate.value = true;
    }, props.delay);
};

const reset = () => {
    shouldAnimate.value = false;
};

onMounted(() => {
    if (props.startOnMount) {
        animate();
    }
});

watch(
    () => props.value,
    () => {
        if (props.startOnMount) {
            animate();
        }
    },
);

defineExpose({ animate, reset });
</script>

<style scoped>
.animated-scale-pop {
    display: inline-block;
    opacity: 0;
    transform: scale(0.3);
}

.animated-scale-pop.animate {
    animation: scalePop v-bind('duration + "ms"') cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards;
}

@keyframes scalePop {
    0% {
        opacity: 0;
        transform: scale(0.3);
    }
    50% {
        opacity: 1;
        transform: scale(1.1);
    }
    70% {
        transform: scale(0.95);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
}
</style>
